module.exports = __webpack_public_path__ + "static/media/workOS-integrations.e4e224cf.svg";